"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonumentTag = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ClassNameForType = {
  alert: 'bg-alertred-10 text-alertred-60 border-alertred-60',
  success: 'bg-green1-10 text-green2-55 border-green2-35',
  warning: 'bg-orange1-15 text-black border-orange1-30',
  blue: 'bg-blue1-10 border-blue1-65',
  orange: 'bg-orange1-30 border-orange1-15',
  white: 'bg-white border-grey-40'
};
// TODO: Rename to Tag with Antd Tag component is completely replaced
var MonumentTag = function MonumentTag(_ref) {
  var className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('tag inline-block tw-caption-regular', ClassNameForType[type], className)
  }, children || type);
};
exports.MonumentTag = MonumentTag;